<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>数据管理(禁止删除)</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
            <div style="margin-right: 20px;"> <el-button type="success" size="small"
                    @click.native="clickAdd">添加数据</el-button></div>
            <div>
                <el-input placeholder="请输入内容" prefix-icon="el-icon-search" size="small" v-model="mobileKey"
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div style="margin-right:20px;">
                <el-select v-model="roomType" placeholder="房间类型" size="small" clearable>
                    <el-option label="脑" value="脑"></el-option>
                    <el-option label="身" value="身"></el-option>
                    <el-option label="食" value="食"></el-option>
                    <el-option label="心" value="心"></el-option>
                </el-select>
            </div>
            <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置查询</el-button></div>
            <div style="margin-left:10px;">
                <el-button type="info" size="small" @click.native="resettingFilter">重置筛选</el-button>
            </div>
        </div>
        <div class="list">
            <el-table ref="tableRef" :data="taskList" style="width: 100%" :row-class-name="tableRowClassName"
                size="mini" max-height="600" stripe :default-sort="{ prop: 'page_id', order: 'ascending' }">
                <el-table-column prop="page_id" label="页面id" fixed="left" width="70"></el-table-column>
                <el-table-column prop="room" label="资源分类" :filters="[
                    { text: '脑', value: '脑' },
                    { text: '身', value: '身' },
                    { text: '食', value: '食' },
                    { text: '心', value: '心' }
                ]" :filter-method="filterRoom"></el-table-column>
                <el-table-column prop="page_name" label="资源名称"></el-table-column>
                <el-table-column prop="page_url" label="资源路径"></el-table-column>
                <el-table-column prop="type" label="资源类型" :filters="[
                    { text: '训练', value: '训练' },
                    { text: '视频', value: '视频' },
                    { text: '音频', value: '音频' },
                    { text: '问卷', value: '问卷' },
                    { text: '特殊', value: '特殊' }
                ]" :filter-method="filterType"></el-table-column>
                <el-table-column prop="is_test" label="是否为测试资源" width="70"></el-table-column>
                <el-table-column prop="is_special" label="档案首页是否展示" width="70"></el-table-column>
                <el-table-column prop="difficulty_level" label="难度等级" :filters="[
                    { text: '超级简单', value: '10' },
                    { text: '简单', value: '20' },
                    { text: '中等', value: '30' },
                    { text: '难', value: '40' }
                ]" :filter-method="filterDifficulty">
                    <template slot-scope="scope">
                        {{ getDifficultyText(scope.row.difficulty_level) }}
                    </template>
                </el-table-column>
                <el-table-column prop="db_table" label="数据对应表名"></el-table-column>
                <el-table-column prop="duration" label="总时长"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" circle
                            @click="clickEdit(scope.$index, scope.row)"></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle
                            @click="clickDelete(scope.$index, scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 30, 50, 100, 150, 200]" :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="delTaskList">删 除</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改数据" :visible.sync="dialogModifyData">
            <el-form :model="modifyData" :rules="rules" ref="modifyData">
                <el-form-item label="资源id" :label-width="formLabelWidth" prop="id">
                    <el-input v-model="modifyData.id" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="小程序id" :label-width="formLabelWidth" prop="page_id">
                    <el-input v-model="modifyData.page_id" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数据名称" :label-width="formLabelWidth" prop="page_name">
                    <el-input v-model="modifyData.page_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数据展示" :label-width="formLabelWidth" prop="room">
                    <el-select v-model="modifyData.room" placeholder="请选择数据展示位置">
                        <el-option label="脑" value="脑"></el-option>
                        <el-option label="身" value="身"></el-option>
                        <el-option label="食" value="食"></el-option>
                        <el-option label="心" value="心"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据类型" :label-width="formLabelWidth" prop="type">
                    <el-select v-model="modifyData.type" placeholder="请选择类型">
                        <el-option label="训练" value="训练"></el-option>
                        <el-option label="视频" value="视频"></el-option>
                        <el-option label="音频" value="音频"></el-option>
                        <el-option label="问卷" value="问卷"></el-option>
                        <el-option label="特殊" value="特殊"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据路径" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.page_url" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="总时长(开始到结束时间)" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.duration" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数据对应表名" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.db_table" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="训练难度等级" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.difficulty_level" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="是否为测试数据" :label-width="formLabelWidth" prop="is_test">
                    <el-select v-model="modifyData.is_test" placeholder="请选择类型">
                        <el-option label="是" value="true"></el-option>
                        <el-option label="否" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="档案首页是否显示" :label-width="formLabelWidth" prop="is_special">
                    <el-select v-model="modifyData.is_special" placeholder="请选择类型">
                        <el-option label="是" value="true"></el-option>
                        <el-option label="否" value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogModify">取 消</el-button>
                <el-button type="primary" @click="submitFormModify">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加数据" :visible.sync="dialogAddData">
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="小程序id" :label-width="formLabelWidth" prop="page_id">
                    <el-input v-model="addData.page_id" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数据名称" :label-width="formLabelWidth" prop="page_name">
                    <el-input v-model="addData.page_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数据展示" :label-width="formLabelWidth" prop="room">
                    <el-select v-model="addData.room" placeholder="请选择数据展示位置">
                        <el-option label="脑" value="脑"></el-option>
                        <el-option label="身" value="身"></el-option>
                        <el-option label="食" value="食"></el-option>
                        <el-option label="心" value="心"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据类型" :label-width="formLabelWidth" prop="type">
                    <el-select v-model="addData.type" placeholder="请选择类型">
                        <el-option label="训练" value="训练"></el-option>
                        <el-option label="视频" value="视频"></el-option>
                        <el-option label="音频" value="音频"></el-option>
                        <el-option label="问卷" value="问卷"></el-option>
                        <el-option label="特殊" value="特殊"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据路径" :label-width="formLabelWidth">
                    <el-input v-model="addData.page_url" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="总时长(开始到结束时间)" :label-width="formLabelWidth">
                    <el-input v-model="addData.duration" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数据对应表名" :label-width="formLabelWidth">
                    <el-input v-model="addData.db_table" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="训练难度等级" :label-width="formLabelWidth">
                    <el-input v-model="addData.difficulty_level" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="是否为测试数据" :label-width="formLabelWidth" prop="is_test">
                    <el-select v-model="addData.is_test" placeholder="请选择类型">
                        <el-option label="是" value="true"></el-option>
                        <el-option label="否" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="档案首页是否显示" :label-width="formLabelWidth" prop="is_special">
                    <el-select v-model="addData.is_special" placeholder="请选择类型">
                        <el-option label="是" value="true"></el-option>
                        <el-option label="否" value="false"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            mobileKey: '', // 搜索条件
            roomType: '', // 房间类型
            pages: 1,
            limit: 10,
            taskList: [],
            total: 0,
            dialogDelete: false,
            clickObject: {},
            dialogModifyData: false,
            modifyData: {
                id: '',
                page_id: '',
                page_name: '',
                page_url: '',
                type: '',
                room: '',
                duration: '',
                db_table: '',
                difficulty_level: null,
                is_test: null,
                is_special: null,
            },
            formLabelWidth: '150px',
            dialogAddData: false,
            addData: {
                page_id: '',
                page_name: '',
                page_url: '',
                type: '',
                room: '',
                duration: '',
                db_table: '',
                difficulty_level: null,
                is_test: null,
                is_special: null,
            },
            rules: {
                id: [
                    { required: true, message: '小程序id为必填项', trigger: 'blur' }
                ],
                page_id: [
                    { required: true, message: '小程序id为必填项', trigger: 'blur' }
                ],
                page_name: [
                    { required: true, message: '数据名称为必填项', trigger: 'blur' }
                ],
                room: [
                    { required: true, message: '请选择数据展示位置', trigger: 'change' }
                ],
                type: [
                    { required: true, message: '请选择数据类型', trigger: 'change' }
                ]
            },
            delData: {}
        }
    },
    created() {
        this.getTaskList()
    },
    computed: {
        // 生成一个根据难度值返回对应文字的函数
        getDifficultyText() {
            return (level) => {
                const map = {
                    10: '超级简单',
                    20: '简单',
                    30: '中等',
                    40: '难'
                };
                return map[level] || '无';
            };
        }
    },
    methods: {
        resettingFilter() {
            // 原有重置逻辑...
            // 新增：清空表格所有列的筛选状态
            this.$refs.tableRef.clearFilter();
            // 注意：需给el-table添加ref="tableRef"
        },
        filterRoom(value, row) {
            // value是筛选值数组（如['脑', '心']），row是当前行数据
            return value.includes(row.room);
        },

        // 2. 资源类型筛选：判断行的type是否在筛选值数组中
        filterType(value, row) {
            return value.includes(row.type);
        },
        filterDifficulty(value, row) {
            // 1. 当未选择筛选项时，返回true显示所有行
            if (!value) return true;

            // 2. 确保value是数组（Element UI有时会传字符串）
            const values = Array.isArray(value) ? value : [value];

            // 3. 类型转换后匹配
            const difficultyNum = Number(row.difficulty_level);
            return values.some(item => Number(item) === difficultyNum);
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        getTaskList() {
            this.$get(`/v1/admin/category_table?&pages=${this.pages}&limit=${this.limit}&key=${this.mobileKey}&room=${this.roomType}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data)
                    res.data.data.data.map((item) => {
                        // 对 item 进行处理
                        if (item.is_test == true) {
                            item.is_test = "是";
                        } else if (item.is_test == false) {
                            item.is_test = "否";
                        }
                        if (item.is_special == true) {
                            item.is_special = "是";
                        } else if (item.is_special == false) {
                            item.is_special = "否";
                        }
                        return item;
                    })
                    this.taskList = res.data.data.data
                    this.total = res.data.total

                    console.log(this.taskList)
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getTaskList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getTaskList()
        },
        clickEdit(index, row) {
            console.log(index, row);
            this.modifyData = row
            this.dialogModifyData = true
            // if (row.is_test == true) {
            //     row.is_test = '是'
            // } else if (row.is_test == false) {
            //     row.is_test = '否'
            // } else {
            //     row.is_test = ''
            // }
            // if (row.is_special == true) {
            //     row.is_special = '是'
            // } else if (row.is_special == false) {
            //     row.is_special = '否'
            // } else {
            //     row.is_special = ''
            // }

        },
        clickDelete(index, row) {
            // console.log(index, row);
            this.dialogDelete = true
            this.delData = row
            console.log(this.delData, '00000000000000')
        },
        delTaskList() {
            let data = {
                id: this.delData.id
            }
            this.$delete('/v1/admin/category_table', data).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功')
                    this.getTaskList()
                } else {
                    this.$msg(res.data.msg)
                }
            });
            this.dialogDelete = false
        },
        clickAdd() {
            this.dialogAddData = true
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    this.addTaskList(this.addData)
                } else {
                    this.$message.error('表单验证失败!')
                    return false;
                }
            });
        },
        // 添加
        addTaskList(data) {
            console.log(data)
            console.log(typeof data.is_special, typeof data.is_test)
            // return
            let newAddData = {
                page_id: '',
                page_name: '',
                page_url: '',
                type: '',
                room: '',
                duration: '',
                db_table: '',
                difficulty_level: null,
                is_test: null,
                is_special: null,
            }
            if (data.difficulty_level == '') {
                console.log('00000000000')
                data.difficulty_level = null
            }
            if (data.difficulty_level !== null && !isNaN(Number(data.difficulty_level))) {
                data.difficulty_level = Number(data.difficulty_level)
                console.log('2222222222', data.difficulty_level)
            }
            if (data.is_test == 'true') {
                data.is_test = true
            } else if (data.is_test == 'false') {
                data.is_test = false
            } else {
                data.is_test = null
            }
            if (data.is_special == 'true') {
                data.is_special = true
            } else if (data.is_special == 'false') {
                data.is_special = false
            } else {
                data.is_special = null
            }
            this.addData.duration = +this.addData.duration
            console.log(data, '添加------------', typeof data.is_special, typeof data.is_test)
            this.$post('/v1/admin/category_table', data).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('添加成功')
                    this.addData = newAddData
                    this.getTaskList()
                    this.dialogAddData = false;
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        closeDialogAdd() {
            this.dialogAddData = false;
            let newAddData = {
                page_id: '',
                page_name: '',
                page_url: '',
                type: '',
                room: '',
                duration: '',
                db_table: '',
                difficulty_level: null
            }
            this.addData = newAddData
        },
        closeDialogModify() {
            this.dialogModifyData = false;
            let newModifyData = {
                id: '',
                page_id: '',
                page_name: '',
                page_url: '',
                type: '',
                room: '',
                duration: '',
                db_table: '',
                difficulty_level: null
            }
            this.modifyData = newModifyData
        },
        submitFormModify() {
            this.$refs.modifyData.validate((valid) => {
                if (valid) {
                    // alert('提交成功!');
                    // 在这里执行你的提交逻辑，比如发送数据到服务器  
                    // this.dialogModifyData = false; // 如果提交后需要关闭对话框，可以取消注释这行代码 
                    console.log(valid, this.modifyData)
                    this.modifyTaskList()
                } else {
                    console.log('表单验证失败!');
                    return false;
                }
            });
        },
        modifyTaskList() {
            const originalIsTest = this.modifyData.is_test;
            const originalIsSpecial = this.modifyData.is_special;
            if (this.modifyData.difficulty_level == '') {
                this.modifyData.difficulty_level = null
            }
            if (this.modifyData.difficulty_level !== null && !isNaN(Number(this.modifyData.difficulty_level))) {
                this.modifyData.difficulty_level = Number(this.modifyData.difficulty_level)
            }
            if (this.modifyData.is_test == 'true' || this.modifyData.is_test == '是') {
                this.modifyData.is_test = true
            } else if (this.modifyData.is_test == 'false' || this.modifyData.is_test == '否') {
                this.modifyData.is_test = false
            } else {
                this.modifyData.is_test = null
            }
            if (this.modifyData.is_special == 'true' || this.modifyData.is_special == '是') {
                this.modifyData.is_special = true
            } else if (this.modifyData.is_special == 'false' || this.modifyData.is_special == '否') {
                this.modifyData.is_special = false
            } else {
                this.modifyData.is_special = null
            }
            console.log(this.modifyData.is_special, typeof this.modifyData.is_special)
            console.log(this.modifyData.is_test, typeof this.modifyData.is_test)
            console.log(this.modifyData, '---------', typeof this.modifyData.difficulty_level);
            this.modifyData.duration = +this.modifyData.duration
            this.$put('/v1/admin/category_table', this.modifyData).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('修改成功')
                    this.getTaskList()
                    this.dialogModifyData = false;
                } else {
                    this.$msg(res.data.msg)
                    this.modifyData.is_test = originalIsTest;
                    this.modifyData.is_special = originalIsSpecial;
                }
            });
        },
        resetting() {
            this.mobileKey = this.roomType = ''
            this.getTaskList();
        },
        Query() {
            this.pages = 1;
            this.getTaskList();
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 200px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>


// WEBPACK FOOTER //
// src/pages/maintenanceData/maintenanceData.vue